import { GetLayout } from "components/get-layout";
import { RoutePermissionFunction } from "router-manager/parts";

function CampanhaURAWhatsapp() {
  return (
    <GetLayout>
      <></>
    </GetLayout>
  );
}

export default CampanhaURAWhatsapp;

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_MASTER",
    "ASCOM"
  ]);
};
